<template>
  <div class="hm-home">
    <div class="card">
      <div class="panel flex item-center flex-between">
        <div>
          <el-button size="small" type="primary" @click="groupOperation('add')"
            >新建指标字段</el-button
          >
        </div>
        <div class="form-wrapper flex flex-1 flex-wrap flex-end mb20">
          <el-input
            class="mr10"
            size="small"
            clearable
            placeholder="请输入指标名"
            v-model.trim="searchConditons.columnName"
            style="width: 150px"
          ></el-input>
          <el-button size="small" type="primary" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mb20">
        <el-table stripe border :data="list" style="width: 100%">
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            width="50"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="columnName"
            label="指标名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            label="关联数据字段"
            align="center"
            prop="task"
          >
            <template slot-scope="scope">
              <span
                class="danger"
                :class="scope.row.relType === 'auto' ? 'success' : 'danger'"
                >{{ scope.row.relType === "auto" ? "是" : "否" }}</span
              >
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <div class="flex flex-center item-center">
                <el-button
                  :class="
                    scope.row.enabledState === 'no' ? 'success' : 'danger'
                  "
                  size="small"
                  type="text"
                  @click="stateOperation(scope.row)"
                >
                  <span>{{
                    scope.row.enabledState === "no" ? "启用" : "停用"
                  }}</span>
                </el-button>
                <div class="line"></div>
                <el-button
                  @click="groupOperation('edit', scope.row)"
                  class="blue"
                  size="small"
                  type="text"
                  >编辑</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="text-center">
        <el-pagination
          background
          layout="total,sizes,  prev, pager, next, jumper"
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          ref="pagination"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="dialogTitle"
      width="1000px"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
      >
        <el-form-item label="指标名称" prop="columnName">
          <el-input
            size="small"
            placeholder="请输入字段名称"
            v-model="ruleForm.columnName"
            :disabled="operationType === 'view'"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="关联数据类型" prop="relType">
          <el-radio-group v-model="ruleForm.relType">
            <el-radio label="auto">自动关联数据计算</el-radio>
            <el-radio label="manual">手动输入</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="选择指标类型"
          prop="fieldType"
          v-if="ruleForm.relType === 'auto'"
        >
          <el-cascader
            v-model="ruleForm.fieldType"
            :options="options"
            size="small"
            @change="changeFieldGType"
            :show-all-levels="false"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="选择可关联字段" v-if="ruleForm.relType === 'auto'">
          <el-select
            placeholder="选择可关联字段"
            multiple
            style="margin-right: 20px"
            size="small"
            v-model="ruleForm.fieldData"
            @change="getFieldData"
          >
            <el-option
              :label="v.itemText"
              :value="v.itemValue"
              v-for="(v, i) in fields"
              :key="i"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="默认字段" v-if="ruleForm.relType === 'auto'">
          <el-tag
            @click="selectField(v)"
            class="pointer"
            v-for="(v, i) in defaultFieldList"
            :key="i"
          >
            {{ v.itemText }}
          </el-tag>
        </el-form-item>
        <el-form-item
          label="关联字段"
          prop="relationField"
          v-if="ruleForm.relType === 'auto'"
        >
          <div>
            <el-tag
              @click="selectField(v)"
              class="pointer"
              v-for="(v, i) in fieldList"
              :key="i"
            >
              {{ v.itemText }}
            </el-tag>
          </div>
          <div class="hm-table">
            <div class="table-header flex  flex-between item-center">
              <div class="th flex-1">条件序号</div>
              <div class="th flex-1">达标条件</div>
              <div class="th flex-1">得分</div>
              <div class="th flex-1">操作</div>
            </div>
            <div class="table-body">
              <div
                class="table-row flex flex-between item-center"
                v-for="(v, i) in ruleForm.expressionList"
                :key="i"
              >
                <div class="td flex-1">{{ i + 1 }}</div>
                <div class="td flex-1 textarea-wrapper">
                  <el-input
                    size="small"
                    type="textarea"
                    :ref="'condition' + i"
                    @blur="getValue($event, i, v, 'condition')"
                    v-model="v.condition"
                    placeholder="请输入达标条件公式，示例：销售额*0.3>3000"
                  ></el-input>
                </div>
                <div class="td flex-1 textarea-wrapper">
                  <el-input
                    size="small"
                    type="textarea"
                    :ref="'score' + i"
                    @blur="getValue($event, i, v, 'score')"
                    v-model="v.score"
                    placeholder="请输入达标得分公式，示例：指标满分*0.3"
                  ></el-input>
                </div>
                <div class="td flex-1">
                  <el-button
                    size="small"
                    type="text"
                    @click="removeExpression(i)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
            <div class="table-footer flex flex-center item-center">
              <div class="add-wrapper">
                <span
                  class="hmicon icon-hao pointer"
                  @click="addExpression"
                ></span>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="是否启用" prop="enabledState">
          <el-switch
            v-model="ruleForm.enabledState"
            active-value="yes"
            inactive-value="no"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
          <span class="form-tip">
            开启后，可以在新增考核任务时选择添加
          </span>
        </el-form-item>
        <div class="flex flex-center">
          <el-button
            v-if="operationType !== 'view'"
            @click="save"
            size="small"
            type="primary"
            >保存</el-button
          >
          <el-button @click="closeDialog" size="small">关闭</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { CnChar2EnChar } from "@/utils/utils";
export default {
  data() {
    const validRelationField = (rule, val, callback) => {
      if (!this.ruleForm.expressionList.length) {
        return callback(new Error("请添加关联字段"));
      }
      this.ruleForm.expressionList.map(v => {
        if (!v.score) {
          return callback(new Error("请输入所有达标条件表达式"));
        }
        if (!v.condition) {
          return callback(new Error("请输入所有得分条件"));
        }
      });
      callback();
    };
    return {
      operationType: "",
      dialogVisible: false,
      ruleForm: {
        columnName: "",
        relType: "auto",
        enabledState: "yes",
        fieldType: [],
        fieldData: [],
        expressionList: [],
        templateType: []
      },
      fields: [],
      fieldList: [],
      defaultFieldList: [
        {
          itemText: "任务满分",
          itemValue: "taskFullPointValue"
        },
        {
          itemText: "指标满分",
          itemValue: "normFullPointValue"
        }
      ],
      dialogTitle: "添加考核指标",
      rules: {
        fieldType: {
          required: true,
          message: "请选择指标类型",
          trigger: "change"
        },
        columnName: {
          required: true,
          message: "请输入制定目标名称",
          trigger: "blur"
        },
        relationField: {
          required: true,
          validator: validRelationField
        }
      },
      searchConditons: {
        columnName: ""
      },
      total: 0,
      currentPage: 1,
      list: [],
      pageSize: 10,
      start: "",
      end: "",
      currentIndex: "",
      currentType: "",
      tempList: [],
      currentRow: {},
      options: [],
      itemValue: ""
    };
  },
  computed: mapGetters(["taskInfo"]),
  created() {},
  mounted() {
    // 从考核任务跳转
    if (this.taskInfo) {
      const { page, itemValue } = this.taskInfo;
      if (page === "ExamineTask") {
        this.dialogVisible = true;
        this.itemValue = itemValue;
        this.ruleForm.fieldType = [itemValue];
        this.queryFieldTempType();
      }
    }
    this.queryList();
  },
  watch: {},
  methods: {
    async queryFieldTempType() {
      const { result } = await this.$store.dispatch("queryFieldTempType");
      let children = [];
      if (!this.itemValue || this.itemValue === "merits_custom") {
        const tempData = await this.$store.dispatch("queryCustomTemplate", {
          dictCode: "merits_custom"
        });
        children = tempData.result;
        children.forEach(v => {
          v.value = v.itemValue;
          v.label = v.itemText;
        });
      }
      result.forEach(v => {
        v.value = v.itemValue;
        v.label = v.itemText;
        if (v.value === "merits_custom") {
          v.children = children;
        }
      });
      this.options = result;
      if (this.itemValue) {
        this.options = this.options.filter(v => v.itemValue === this.itemValue);
      }
    },
    async changeFieldGType() {
      const autoTemplateType = this.ruleForm.fieldType[0];
      let dictCode = autoTemplateType;
      if (this.ruleForm.fieldType.length > 1) {
        dictCode = this.ruleForm.fieldType[this.ruleForm.fieldType.length - 1];
      }
      const { result } = await this.$store.dispatch("queryField", {
        autoTemplateType,
        dictCode
      });
      this.ruleForm.fieldData = [];
      this.fields = result;
    },
    // 选择可关联字段
    getFieldData() {
      const list = [];
      this.fields.map(v => {
        this.ruleForm.fieldData.map(o => {
          if (v.itemValue === o) {
            list.push({
              itemText: v.itemText,
              itemValue: v.itemValue
            });
          }
        });
      });
      this.fieldList = list;
    },
    // 获取光标位置
    getValue(e, i, v, type) {
      this.start = e.target.selectionStart;
      this.end = e.target.selectionEnd;
      this.text = v[type];
      this.currentIndex = i;
      this.currentType = type;
    },
    selectField(v) {
      if (!this.start && this.start !== 0) {
        return;
      }
      const result =
        this.text.substring(0, this.start) +
        `${v.itemText}` +
        this.text.substring(this.end);
      this.ruleForm.expressionList[this.currentIndex][
        this.currentType
      ] = result;
      this.$refs[this.currentType + this.currentIndex][0].focus();
    },
    addExpression() {
      this.ruleForm.expressionList.push({
        condition: "",
        score: ""
      });
    },
    removeExpression(i) {
      this.ruleForm.expressionList.splice(i, 1);
    },
    resetRuleForm() {
      setTimeout(() => {
        this.fieldList = [];
        this.ruleForm.fieldData = [];
        this.ruleForm.expressionList = [];
        this.$refs.ruleForm.resetFields();
      }, 0);
    },
    async queryGroupDetails(row) {
      const { result } = await this.$store.dispatch(
        "queryIndicatorFieldDetails",
        {
          id: row.id
        }
      );
      if (result.relType === "auto") {
        const ruleForm = JSON.parse(result.calcRemark);
        for (let key in ruleForm) {
          if (this.ruleForm.hasOwnProperty(key) && ruleForm[key]) {
            this.ruleForm[key] = ruleForm[key];
          }
        }
        // 回显可关联字段
        await this.changeFieldGType();
        this.ruleForm.fieldData = ruleForm.fieldData;
        this.getFieldData();
      } else {
        this.ruleForm = result;
      }
    },
    drawDateChange() {
      this.ruleForm.planStartDate = "";
      this.ruleForm.planEndDate = "";
      this.ruleForm.timeDate = "";
    },
    async stateOperation(row) {
      const relType = row.enabledState === "no" ? "启用" : "停用";
      const result = await this.$confirm(`${relType}指标字段?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        await this.$store.dispatch("changeIndicatorFieldStatus", {
          id: row.id
        });
        this.queryList();
      }
    },
    async queryList() {
      const params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      Object.assign(params, this.searchConditons);
      const { result } = await this.$store.dispatch(
        "queryIndicatorFieldList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    groupOperation(type, row) {
      this.dialogVisible = true;
      this.resetRuleForm();
      this.queryFieldTempType();
      this.operationType = type;
      switch (type) {
        case "add":
          this.dialogTitle = "添加考核指标";
          break;
        case "edit":
          this.dialogTitle = "编辑考核指标";
          this.currentRow = row;
          this.queryGroupDetails(row);
          break;
        default:
          break;
      }
    },
    async save() {
      let relDictId = "";
      const valid = await this.$refs.ruleForm.validate();
      if (valid) {
        let url = "addIndicatorField";
        let params = null;
        switch (this.ruleForm.relType) {
          case "auto":
            // eslint-disable-next-line no-case-declarations
            const expressionList = this.getExpressionList();
            params = JSON.parse(JSON.stringify(this.ruleForm));
            if (this.ruleForm.fieldType.length > 1) {
              relDictId = this.ruleForm.fieldType[
                this.ruleForm.fieldType.length - 1
              ];
            } else {
              const itemValue = this.ruleForm.fieldType[0];
              relDictId = this.options.find(v => v.itemValue === itemValue).id;
            }
            Object.assign(params, {
              relDictId,
              calcRemark: JSON.stringify(params),
              autoTemplateType: this.ruleForm.fieldType[0],
              autoTemplateContent: JSON.stringify(expressionList)
            });
            break;
          case "manual":
            params = {
              columnName: this.ruleForm.columnName,
              relType: this.ruleForm.manual
            };
            break;
          default:
            break;
        }
        if (this.operationType === "edit") {
          url = "editIndicatorField";
        }
        Object.assign(params, {
          id: this.currentRow.id
        });
        await this.$store.dispatch(url, params);
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.queryList();
        this.dialogVisible = false;
      }
    },
    getExpressionList() {
      const expressionList = JSON.parse(
        JSON.stringify(this.ruleForm.expressionList)
      );
      expressionList.forEach(v => {
        v.conditionFormat = v.condition;
        v.scoreFormat = v.score;
      });
      expressionList.forEach(v => {
        v.conditionFormat = v.condition;
        v.scoreFormat = v.score;
        const list = [...this.fieldList, ...this.defaultFieldList];
        list.map(o => {
          v.conditionFormat = CnChar2EnChar(
            v.conditionFormat.replace(new RegExp(o.itemText, "g"), o.itemValue)
          );
          v.scoreFormat = CnChar2EnChar(
            v.scoreFormat.replace(new RegExp(o.itemText, "g"), o.itemValue)
          );
        });
      });
      return expressionList;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  background: #fff;
  padding: 15px;
}
.table-panel {
  background: #fff;
  padding: 15px;
}

.table {
  .line {
    width: 1px;
    margin: 0 10px;
    height: 12px;
    background: #ddd;
  }
}

.hm-table {
  border-radius: 6px;
  border: 1px solid #dddddd;
  line-height: 14px;
  .table-header {
    padding: 15px;
    background: #f7f7f7;
    text-align: center;
    .th {
      font-weight: bold;
    }
  }
  .table-body {
    .table-row {
      padding: 5px 15px;
    }
    .table-row:nth-child(even) {
      background: #f7f7f7;
    }
    text-align: center;
  }
  .table-footer {
    border-top: 1px solid #dddddd;
    padding: 6px;
  }
  .textarea-wrapper {
    margin: 0 5px;
  }
}
</style>
